export const userLogin = {
    regex: /^([a-z0-9--_]+)$/i,
    minLength: 2,
    maxLength: 20,
    // @TODO: update when there is a new page. Files: rules.js, RegistrationRequest.php
    invalid: [
        'administrator',
        'admins',
        'administrators',
        'login',
        'register',
        'add-acount',
        'become-creator',
        'create',
        'creator',
        'creator-dashboard',
        'creator-support',
        'edit-profile',
        'profile',
        'followers',
        'following',
        'help-faqs',
        'how-it-works',
        'logos',
        'my-referrals',
        'payment-details',
        'privacy-policy',
        'complaints-content-removal-appeals',
        'anti-human-trafficking-policy',
        'referrals',
        'terms',
        'home',
        'messages',
        'my-notification',
        'performance',
        'administration',
        'faqs',
        'blog',
        'trial',
        'purchases',
        'catalogue',
        'shared-media',
        'stash',
        'direct-upload-test',
    ],
};


export const privateRoutes = [
    'followers',
    'payment-details',
    'following',
    'catalogue',
    'shared-media',
    'promotion',
    'home',
    'edit-profile',
    'settings',
    'creator-advanced-settings',
    'creator-dashboard',
    'stash',
    'creator-support',
    'messages',
    'become-creator',
    'create',
    'creator',
    'my-referrals',
    'add-account',
    'performance',
    'welcome-messages',
    'followers',
    'payment-details',
    'following',
    'promotion',
    'my-notification',
    'direct-upload-test',
];

export const alphaNumDashSpace = {
    regex: /^([a-z0-9--_\s]+)$/i,
};

export const email = {
    regex: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
};

export const password = {
    regex: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/,
};

export const bio = {
    maxLength: 1000,
};

export const subscriptionPrice = {
    minAmount: 4.99,
    maxAmount: 50,
};

export const tipPrice = {
    minAmount: 5,
    maxAmount: 100
};

export const ppvPrice = {
    minAmount: 3.99,
    maxAmount: 100,
};

export const imageOnly = {
    mime: [
        'image/jpeg',
        'image/png',
    ],
};

export const promoPrice = {
    minAmount: 0.49,
    maxAmount: 50,
};

export const discountPrice = {
    minAmount: 0.49,
    maxAmount: 50,
};

export const linkNameLength = {
    minLength: 1,
    maxLength: 20,
};

export const post = {
    maxFile: 10,
    maxFilesize: 1073741824, // bytes
};
